<template>
  <div id="ihealth-layout" class="theme-blue">
  
  <!-- Main body area -->
  <div class="main p-2 py-3 p-xl-5 ">
      <div class="body d-flex p-0 p-xl-5">
          <div class="container-xxl">
  
              <div class="row g-0">
  
                  <div class="col-lg-12 d-flex justify-content-center align-items-center border-0 rounded-lg auth-h100">
                      <div class="w-100 p-3 p-md-5 card border-0 bg-dark text-light" style="max-width: 32rem;">
                          <!-- Form -->
                          <form class="row g-1 p-3 p-md-4" @submit.prevent="signIn" id="sign" ref="form">
  
                              <!-- Password -->
                              <div class="col-12">
                                  <div class="mb-2">
                                      <div class="form-label">
                                          <span class="d-flex justify-content-between align-items-center">
                                              Code
                                          </span>
                                      </div>
                                      <input v-model="otp" v-validate="{ required: true, min: 3, max:6}" name="code" type="text" class="form-control form-control-lg" placeholder="code  ">
                                      <span class="inputError">{{ errors.first('code') }}</span>
                                  </div>
                              </div>
  
                              <div class="col-12 text-center mt-4">
                                <button type="submit" :disabled="loading" class="btn btn-lg btn-block btn-light lift text-uppercase" atl="signin">SIGN IN</button>
                              </div>
                          </form>
                          <!-- End Form -->
                          
                      </div>
                  </div>
              </div>
              
          </div>
      </div>
  
  </div>
  
  </div>
  </template>
  <script>
    import axios from "axios";
    import store from '../store';
    import user  from '../store/user'
    
    export default {
      // eslint-disable-next-line vue/multi-word-component-names
      name: 'OTP',
      data: ()=>({
        otp : '',
        loading: false,
      }),
      methods: {
        async signIn(){
          const validForm = await this.formIsValid
          if(validForm){
            this.loading = true
            axios.post(store.getters.getUrl+'/Auth/Validate', {username: this.$route.params.user, code: this.otp})
            .then(response => {
              if(response.data.isError == null){
                this.$toast.success('Uğurlu giriş')
              
                user.dispatch('updateLogin',{expires:1, user:response.data.result})
  
                this.loading = false
                location.href='/'
              }
              else {
                this.$toast.error(response.data.responseException);
                this.loading = false
              }
            })
            .catch(error=> {
              if(error.response.status === 404){
                this.$toast.error('İstifadəçi adı və ya parol səhvdir.')
              }
              this.loading = false
            })
          } 
          else {
            this.$toast.error('Səvhlikləri düzəldin!')
            this.loading = false
          }
        },
      },
      computed : {   
        formIsValid(){
          // eslint-disable-next-line vue/no-async-in-computed-properties, no-async-promise-executor
          return new Promise(async (resolve, reject) => {
            try {
              const valid = await this.$validator.validate();
              resolve(valid);
            } catch (error) {
              reject(error);
            }
          });
        }
      },

    }
  </script>
  <style>
    .inputError {
      color: #ff0000;
      font-weight: bold;
    }
  
    .forgotpassword {
      background: transparent;
      border: none;
    }
  
    .forgotpassword:hover {
      color: #ffb62d;
    }
    canvas {
      display: block;
      margin: 20px auto;
    }
  </style>